import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

let state = {
  managerFilter: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
